module.exports = {
    bindings: {
        roleGroups: '<',
        selectionChanged: '&'
    },
    controller: rolePickerController,
    templateUrl: 'customs-offices/components/role-picker.html'
};

rolePickerController.$inject = ['customsOfficeDataService', 'roleSelectorModal'];

function rolePickerController(customsOfficeDataService, roleSelectorModal) {
    var vm = {
        $onInit: attached,
        selectedRoles: [],
        unselectedRoles: [],
        roleGroups: [],
        service: customsOfficeDataService,
        userInput: null,
        showModal: showModal,
        itemSelected: itemSelected,
        removeRole: removeRole,
        onBlur: onBlur,
        onFocus: onFocus,
        onEnter: onEnter
    };

    function showModal() {
        roleSelectorModal
            .show(vm.roleGroups)
            .result
            .then(modalClosed)
            .catch(function (res) {
                if (!(res === 'cancel' || res === 'escape key press' || res === 'backdrop click')) {
                    throw res;
                }
            });
    }

    function attached() {
        updateRoles();
    }

    function onFocus() {
        updateRoles();
    }

    function onBlur() {

    }

    function onEnter() {

    }

    // available means possible and not already selected
    function updateRoles() {
        vm.service.updateRoleGroups();
        vm.selectedRoles = vm.service.getSelectedRoles();
        vm.unselectedRoles = vm.service.getUnselectedRoles();
    }

    function removeRole(role) {
        role.isSelected = false;
        updateRoles();
        if (vm.selectionChanged)
            vm.selectionChanged({ roles: vm.roles })
    }

    function modalClosed() {
        updateRoles();
    }

    function itemSelected(item, model) {

        vm.userInput = null;
        if (item) {
            item.isSelected = true;
            updateRoles();
        }

        if (vm.selectionChanged)
            vm.selectionChanged({ roles: vm.roles });

    }

    return vm;

}
